module.exports = __webpack_public_path__ + "img/48.195a8aa5.png";